<script>
  import Modal from '@components/general/modal.svelte'
  import Image from '@components/general/image.svelte'
  import Button from '@components/buttons/button.svelte'
  import { ChevronLeft, ChevronRight } from 'lucide-svelte'

  let { src, index = $bindable(0), title = "Preview image", alt = "", cycle = false, open = $bindable(false), onClose } = $props()

  let multiple = $derived(Array.isArray(src) && src.length > 1)

  let currentSrc = $derived(multiple ? src.at(index) : src)

  let paginationText = $derived(multiple ? `${index + 1}/${src.length}` : "")

  let currentTitle = $derived(multiple ? `${title} (${paginationText})` : title)

  function previous() {
    const previousIndex = index - 1
    if (previousIndex < 0) {
      cycle ? index = src.length - 1 : index = 0
    } else {
      index = previousIndex
    }
  }

  function next() {
    const nextIndex = index + 1
    if (nextIndex >= src.length) {
      cycle ? index = 0 : index = src.length - 1
    } else {
      index = nextIndex
    }
  }

  function handleKeyDown(e) {
    if (e.key === "ArrowLeft") return previous()
    if (e.key === "ArrowRight") return next()
  }

</script>

<svelte:window onkeydown={handleKeyDown} />

<Modal bind:open title={currentTitle} {onClose}>

  <Image src={currentSrc} loading="lazy" class="size-full" alt={alt} />

  {#snippet footer()}
    {#if multiple}
      <Button onclick={previous} disabled={!cycle && index === 0} Icon={ChevronLeft} />
      <Button onclick={next} disabled={!cycle && index === src.length - 1} Icon={ChevronRight} />
    {/if}
  {/snippet}
  
</Modal>